import { Link } from 'react-router-dom';

import { BsBuilding, BsChevronRight, BsClockHistory } from 'react-icons/bs';

import SectionCard from '#globalComponents/Card/SectionCard';
import EmptyState from '#globalComponents/EmptyState/EmptyState';
import { formatDate } from '#lib/dateUtils';

import { useRecentCompaniesStore } from '../../stores/recentCompaniesStore';

const RecentCompaniesCard = () => {
	const recentCompanies = useRecentCompaniesStore((s) => s.recentCompanies);
	const clearRecentCompanies = useRecentCompaniesStore((s) => s.clearRecentCompanies);

	const clearButton = recentCompanies.length > 0 && (
		<button
			type="button"
			onClick={clearRecentCompanies}
			className="flex-shrink-0 text-xs text-bgBase-800 transition-colors hover:text-text"
		>
			Verlauf leeren
		</button>
	);

	return (
		<SectionCard
			title="Zuletzt angesehen"
			subtitle="Gespeichert in diesem Browser"
			icon={BsClockHistory}
			headerAction={clearButton}
			bodyClassName="p-0"
		>
			{recentCompanies.length === 0 ? (
				<EmptyState
					icon={BsBuilding}
					title="Noch keine Unternehmen angesehen"
					description="Unternehmen, die Sie öffnen, erscheinen hier für den schnellen Zugriff."
				/>
			) : (
				<ul className="divide-y divide-bgBase-500">
					{recentCompanies.map((company) => (
						<li key={company.id}>
							<Link
								to={`/leads/company/${company.id}`}
								className="group flex items-center gap-3 px-4 py-3 transition-colors hover:bg-primary-100"
							>
								<div className="flex h-8 w-8 flex-shrink-0 items-center justify-center rounded-control bg-bgBase-300 text-bgBase-800 group-hover:bg-white group-hover:text-primary-600">
									<BsBuilding className="h-4 w-4" />
								</div>
								<div className="min-w-0 flex-1">
									<p className="truncate text-sm font-medium text-text group-hover:text-primary-700">
										{company.companyName}
									</p>
									<p className="truncate text-xs text-bgBase-800">
										{[company.city, formatDate(company.viewedAt)].filter(Boolean).join(' · ')}
									</p>
								</div>
								<BsChevronRight className="h-3.5 w-3.5 flex-shrink-0 text-bgBase-800 group-hover:text-primary-600" />
							</Link>
						</li>
					))}
				</ul>
			)}
		</SectionCard>
	);
};

export default RecentCompaniesCard;
